function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.0713,
  cy: 12.9285,
  r: 11.8,
  stroke: "#708390",
  strokeWidth: 1.4
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 8,
  y: 7,
  width: 11,
  height: 11
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.02441 7.88477H18.1121V17.9725H8.02441V7.88477Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4645 12.9286L18.03 8.36309C18.081 8.31237 18.1121 8.24232 18.1121 8.16498C18.1121 8.0103 17.9869 7.88477 17.8319 7.88477C17.7549 7.88477 17.6848 7.91615 17.6338 7.96687L13.0683 12.5324L8.50274 7.96687C8.45202 7.91615 8.38197 7.88477 8.30463 7.88477C8.14967 7.88477 8.02441 8.0103 8.02441 8.16498C8.02441 8.24232 8.05552 8.31237 8.10652 8.36337L12.672 12.9286L8.10652 17.4942C8.05552 17.5449 8.02441 17.6149 8.02441 17.6923C8.02441 17.8472 8.14967 17.9725 8.30463 17.9725C8.38197 17.9725 8.45202 17.9411 8.50274 17.8904L13.0683 13.3248L17.6338 17.8904C17.6848 17.9411 17.7549 17.9725 17.8319 17.9725C17.9869 17.9725 18.1121 17.8472 18.1121 17.6923C18.1121 17.6149 18.081 17.5449 18.03 17.4942L13.4645 12.9286Z",
  fill: "black",
  stroke: "#708390"
}));

var SvgCloseCircle = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-circle.b4145720.svg";
export { ForwardRef as ReactComponent };